import { Entity, GenericFieldValue, OperatorType, ViewAcl } from '@msdk/definitions'

import { ReloadOptions, RowCustomActionArgs } from './custom-action-args'
import { CustomActionBase } from './custom-action-base'

export abstract class RowCustomAction extends CustomActionBase {
  protected readonly reload: (options?: ReloadOptions) => void
  protected row: Entity
  protected viewAcl: ViewAcl
  protected addOrUpdateFilter: (fieldName: string, operator: OperatorType, value: GenericFieldValue) => void
  protected value: GenericFieldValue = null

  constructor(args: RowCustomActionArgs) {
    super(args)
    this.reload = args.reload
    this.row = args.row
    this.viewAcl = args.viewAcl
    this.addOrUpdateFilter = args.addOrUpdateFilter
  }

  public setRow(row: Entity): void {
    this.row = row
  }
}
